import { render } from "./CertAlcoholApprovedPending.vue?vue&type=template&id=86982f0e&scoped=true"
import script from "./CertAlcoholApprovedPending.vue?vue&type=script&lang=js"
export * from "./CertAlcoholApprovedPending.vue?vue&type=script&lang=js"

import "./CertAlcoholApprovedPending.vue?vue&type=style&index=0&id=86982f0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86982f0e"]])

export default __exports__